import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  socialCommerceLoading: false,
  socialCommerceList: [],
  considatedCalculation: {},
  total: 0,
  size: 0,
  totalPages: 0,
  page: 0,
  loaderForButton: false,
};
const SocialCommerceSlice = createSlice({
  name: "socialCommerce",
  initialState,
  reducers: {
    setSocialCommerceLoading(state, action) {
      state.socialCommerceLoading = action?.payload;
    },
    setSocialCommerceList(state, action) {
      state.socialCommerceList = action?.payload?.pagination
        ? [...state.socialCommerceList, ...action?.payload?.socialCommerceList]
        : action?.payload?.socialCommerceList;
      state.considatedCalculation = action?.payload?.considatedCalculation;
      state.total = action?.payload?.total;
      state.totalPages = action?.payload?.totalPages;
      state.page = action?.payload?.page;
      state.size = action?.payload?.size;
      state.loaderForButton = action?.payload?.loaderForButton;
      state.socialCommerceLoading = action?.payload?.socialCommerceLoading;
    },
    setLoaderForButton(state, action) {
      state.loaderForButton = action?.payload;
    },
    clearSocialCommerce(action, state) {
      return initialState;
    },
  },
});

export const socialCommerceActions = SocialCommerceSlice.actions;

export default SocialCommerceSlice;
